import { IconName } from '@fortawesome/fontawesome-common-types'
import { URL } from './url'

interface param {
  url: string
  title: string
  text: string
  icon: IconName
  image?: string
  indent_1: boolean
  indent_2: boolean
}

export const EXPORT_LIST: param[] = [
  {
    url: URL.CSV_EXPORT.path,
    title: "計測データ",
    text: "各種計測データをCSV形式で出力することができます。",
    icon: "file-csv",
    image: "/static/images/export/image_1.png",
    indent_1: false,
    indent_2: true,
  },
  {
    url: URL.DATA_SHEET_EXPORT.path,
    title: "比較データ",
    text: "各データを比較したデータシートを出力することができます。",
    icon: "file-excel",
    image: "/static/images/export/image_2.png",
    indent_1: false,
    indent_2: true,
  },
]

export default EXPORT_LIST
